// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_EuclideanRing = require("../Data.EuclideanRing/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Map = require("../Data.Map/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_String_CodePoints = require("../Data.String.CodePoints/index.js");
var Data_String_CodeUnits = require("../Data.String.CodeUnits/index.js");
var Data_String_Common = require("../Data.String.Common/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Random = require("../Effect.Random/index.js");
var Standard = (function () {
    function Standard() {

    };
    Standard.value = new Standard();
    return Standard;
})();
var UniqueDiagonal = (function () {
    function UniqueDiagonal() {

    };
    UniqueDiagonal.value = new UniqueDiagonal();
    return UniqueDiagonal;
})();
var Tuple3 = (function () {
    function Tuple3(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    Tuple3.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new Tuple3(value0, value1, value2);
            };
        };
    };
    return Tuple3;
})();
var NoSolution = (function () {
    function NoSolution() {

    };
    NoSolution.value = new NoSolution();
    return NoSolution;
})();
var Unique = (function () {
    function Unique(value0) {
        this.value0 = value0;
    };
    Unique.create = function (value0) {
        return new Unique(value0);
    };
    return Unique;
})();
var NotUnique = (function () {
    function NotUnique(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    NotUnique.create = function (value0) {
        return function (value1) {
            return new NotUnique(value0, value1);
        };
    };
    return NotUnique;
})();
var CellSet = (function () {
    function CellSet(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    CellSet.create = function (value0) {
        return function (value1) {
            return new CellSet(value0, value1);
        };
    };
    return CellSet;
})();
var Fixed = (function () {
    function Fixed(value0) {
        this.value0 = value0;
    };
    Fixed.create = function (value0) {
        return new Fixed(value0);
    };
    return Fixed;
})();
var Possible = (function () {
    function Possible(value0) {
        this.value0 = value0;
    };
    Possible.create = function (value0) {
        return new Possible(value0);
    };
    return Possible;
})();
var NoSolution$prime = (function () {
    function NoSolution$prime() {

    };
    NoSolution$prime.value = new NoSolution$prime();
    return NoSolution$prime;
})();
var NotUnique$prime = (function () {
    function NotUnique$prime(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    NotUnique$prime.create = function (value0) {
        return function (value1) {
            return new NotUnique$prime(value0, value1);
        };
    };
    return NotUnique$prime;
})();
var AtLeast$prime = (function () {
    function AtLeast$prime(value0) {
        this.value0 = value0;
    };
    AtLeast$prime.create = function (value0) {
        return new AtLeast$prime(value0);
    };
    return AtLeast$prime;
})();
var zip3 = function (f) {
    return function (as) {
        return function (bs) {
            return function (cs) {
                var v = new Tuple3(Data_Array.uncons(as), Data_Array.uncons(bs), Data_Array.uncons(cs));
                if (v.value0 instanceof Data_Maybe.Just && (v.value1 instanceof Data_Maybe.Just && v.value2 instanceof Data_Maybe.Just)) {
                    return Data_Array.cons(f(v.value0.value0.head)(v.value1.value0.head)(v.value2.value0.head))(zip3(f)(v.value0.value0.tail)(v.value1.value0.tail)(v.value2.value0.tail));
                };
                return [  ];
            };
        };
    };
};
var unique = function (dictEq) {
    return function (dictOrd) {
        return function (xs) {
            return Data_Array.fromFoldable(Data_Set.foldableSet)(Data_Map.keys(Data_Foldable.foldl(Data_Foldable.foldableArray)(function (m) {
                return function (x) {
                    return Data_Map_Internal.insert(dictOrd)(x)(Data_Unit.unit)(m);
                };
            })(Data_Map_Internal.empty)(xs)));
        };
    };
};
var transpose = function (l) {
    var v = Data_Array.uncons(l);
    if (v instanceof Data_Maybe.Nothing) {
        return [  ];
    };
    if (v instanceof Data_Maybe.Just) {
        var v1 = Data_Array.uncons(v.value0.head);
        if (v1 instanceof Data_Maybe.Nothing) {
            return transpose(v.value0.tail);
        };
        if (v1 instanceof Data_Maybe.Just) {
            return Data_Array.cons(Data_Array.cons(v1.value0.head)(Data_Array.mapMaybe(Data_Array.head)(v.value0.tail)))(transpose(Data_Array.cons(v1.value0.tail)(Data_Array.mapMaybe(Data_Array.tail)(v.value0.tail))));
        };
        throw new Error("Failed pattern match at Sudoku.Internal (line 175, column 35 - line 180, column 58): " + [ v1.constructor.name ]);
    };
    throw new Error("Failed pattern match at Sudoku.Internal (line 173, column 15 - line 180, column 58): " + [ v.constructor.name ]);
};
var toEither = function (v) {
    return function (v1) {
        if (v instanceof Data_Maybe.Nothing) {
            return new Data_Either.Left(v1);
        };
        if (v instanceof Data_Maybe.Just) {
            return new Data_Either.Right(v.value0);
        };
        throw new Error("Failed pattern match at Sudoku.Internal (line 191, column 1 - line 191, column 46): " + [ v.constructor.name, v1.constructor.name ]);
    };
};
var showGridWithPossibilities = function (v) {
    var showCell = function (v1) {
        if (v1 instanceof Fixed) {
            return Data_Show.show(Data_Show.showChar)(v1.value0) + "          ";
        };
        if (v1 instanceof Possible) {
            return (function (x) {
                return x + "]";
            })(Data_Foldable.foldl(Data_Foldable.foldableArray)(function (acc) {
                return function (x) {
                    return acc + (function () {
                        var $56 = Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqChar)(x)(v1.value0);
                        if ($56) {
                            return Data_Show.show(Data_Show.showChar)(x);
                        };
                        return " ";
                    })();
                };
            })("[")(v.value1));
        };
        throw new Error("Failed pattern match at Sudoku.Internal (line 106, column 5 - line 106, column 52): " + [ v1.constructor.name ]);
    };
    var $104 = Data_String_Common.joinWith("\x0a");
    var $105 = Data_Functor.map(Data_Functor.functorArray)((function () {
        var $107 = Data_String_Common.joinWith(" ");
        var $108 = Data_Functor.map(Data_Functor.functorArray)(showCell);
        return function ($109) {
            return $107($108($109));
        };
    })());
    return function ($106) {
        return $104($105($106));
    };
};
var showGrid = function (dictShow) {
    var $110 = Data_String_Common.joinWith("\x0a");
    var $111 = Data_Functor.map(Data_Functor.functorArray)((function () {
        var $113 = Data_String_Common.joinWith(" ");
        var $114 = Data_Functor.map(Data_Functor.functorArray)(Data_Show.show(dictShow));
        return function ($115) {
            return $113($114($115));
        };
    })());
    return function ($112) {
        return $110($111($112));
    };
};
var searchResultShow = function (dictShow) {
    return new Data_Show.Show(function (v) {
        if (v instanceof NoSolution) {
            return "NoSolution";
        };
        if (v instanceof Unique) {
            return "(Unique " + (Data_Show.show(dictShow)(v.value0) + ")");
        };
        if (v instanceof NotUnique) {
            return "(Unique " + (Data_Show.show(dictShow)(v.value0) + (" " + (Data_Show.show(dictShow)(v.value1) + (" " + ")"))));
        };
        throw new Error("Failed pattern match at Sudoku.Internal (line 45, column 1 - line 48, column 83): " + [ v.constructor.name ]);
    });
};
var replaceAt = function (idx) {
    return function (f) {
        return function (xs) {
            return Data_Maybe.fromMaybe(xs)(Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.index(xs)(idx))(function (x) {
                return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.deleteAt(idx)(xs))(function (xs1) {
                    return Data_Array.insertAt(idx)(f(x))(xs1);
                });
            }));
        };
    };
};
var replace2D = function (i) {
    return function (v) {
        var v1 = new Data_Tuple.Tuple(Data_Int.quot(i)(9), Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(i)(9));
        return replaceAt(v1.value0)(replaceAt(v1.value1)(Data_Function["const"](v)));
    };
};
var readCell = function (v) {
    return function (v1) {
        var $69 = v1 === v.value0;
        if ($69) {
            return Data_Either.Right.create(new Possible(v.value1));
        };
        var $70 = Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqChar)(v1)(v.value1);
        if ($70) {
            return new Data_Either.Right(new Fixed(v1));
        };
        return Data_Either.Left.create("char " + (Data_Show.show(Data_Show.showChar)(v1) + ("is not one of " + Data_Show.show(Data_Show.showArray(Data_Show.showChar))(v.value1))));
    };
};
var randomArray = function (input) {
    return function __do() {
        var k = Effect_Random.randomInt(0)(Data_Array.length(input) - 1 | 0)();
        return Data_Maybe.fromMaybe(Control_Applicative.pure(Effect.applicativeEffect)([  ]))(Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.index(input)(k))(function (v) {
            return Control_Bind.bind(Data_Maybe.bindMaybe)(Data_Array.deleteAt(k)(input))(function (arr) {
                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)(Data_Functor.map(Effect.functorEffect)(Data_Array.cons(v))(randomArray(arr)));
            });
        }))();
    };
};
var on = function (g) {
    return function (f) {
        return function (x) {
            return function (y) {
                return g(f(x))(f(y));
            };
        };
    };
};
var numbers = new CellSet(".", [ "1", "2", "3", "4", "5", "6", "7", "8", "9" ]);
var mkCellSet = function (empty) {
    return function (allValues) {
        if (Data_Array.length(allValues) !== 9) {
            return new Data_Either.Left("char set must have exactly 9 characters");
        };
        if (Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqChar)(empty)(allValues)) {
            return new Data_Either.Left("the empty character cannot also be in the list of values");
        };
        if (Data_Array.length(unique(Data_Eq.eqChar)(Data_Ord.ordChar)(allValues)) !== Data_Array.length(allValues)) {
            return new Data_Either.Left("all characters must be unique");
        };
        if (Data_Boolean.otherwise) {
            return new Data_Either.Right(new CellSet(empty, allValues));
        };
        throw new Error("Failed pattern match at Sudoku.Internal (line 73, column 1 - line 73, column 57): " + [ empty.constructor.name, allValues.constructor.name ]);
    };
};
var isUnique$prime = function (dictEq) {
    return function (dictOrd) {
        return function (arr) {
            return function (seen) {
                var f = function (x) {
                    var $75 = Data_Maybe.isJust(Data_Map_Internal.lookup(dictOrd)(x.head)(seen));
                    if ($75) {
                        return false;
                    };
                    return isUnique$prime(dictEq)(dictOrd)(x.tail)(Data_Map_Internal.insert(dictOrd)(x.head)(Data_Unit.unit)(seen));
                };
                return Data_Maybe.fromMaybe(true)(Data_Functor.map(Data_Maybe.functorMaybe)(f)(Data_Array.uncons(arr)));
            };
        };
    };
};
var isUnique = function (dictEq) {
    return function (dictOrd) {
        return function (l) {
            return isUnique$prime(dictEq)(dictOrd)(l)(Data_Map_Internal.empty);
        };
    };
};
var index2D = function (arr) {
    return function (i) {
        var v = new Data_Tuple.Tuple(Data_Int.quot(i)(9), Data_EuclideanRing.mod(Data_EuclideanRing.euclideanRingInt)(i)(9));
        return Control_Bind.bindFlipped(Data_Maybe.bindMaybe)(function (arr$prime) {
            return Data_Array.index(arr$prime)(v.value0);
        })(Data_Array.index(arr)(v.value1));
    };
};
var functorSearchResult = new Data_Functor.Functor(function (f) {
    return function (v) {
        if (v instanceof NoSolution) {
            return NoSolution.value;
        };
        if (v instanceof Unique) {
            return new Unique(f(v.value0));
        };
        if (v instanceof NotUnique) {
            return new NotUnique(f(v.value0), f(v.value1));
        };
        throw new Error("Failed pattern match at Sudoku.Internal (line 49, column 1 - line 52, column 50): " + [ f.constructor.name, v.constructor.name ]);
    };
});
var emptySudoku = Data_String_CodeUnits.fromCharArray(Data_Unfoldable.replicate(Data_Unfoldable.unfoldableArray)(81)("."));
var diagonalOf = function (str) {
    var idxs = Data_Functor.map(Data_Functor.functorArray)(function (x) {
        return 10 * x | 0;
    })(Data_Array.range(0)(8));
    var onlyDiag = function (s) {
        return function (v) {
            var $86 = Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqInt)(v.value1)(idxs);
            if ($86) {
                return s + Data_String_CodeUnits.singleton(v.value0);
            };
            return s;
        };
    };
    return Data_Foldable.foldl(Data_Foldable.foldableArray)(onlyDiag)("")(Data_Array.zip(Data_String_CodeUnits.toCharArray(str))(Data_Array.range(0)(80)));
};
var colors = new CellSet(".", [ "R", "O", "Y", "L", "G", "B", "I", "P", "V" ]);
var chunksOf = function (n) {
    return function (xs) {
        var $89 = Data_Array["null"](Data_Array.drop(n)(xs));
        if ($89) {
            return Control_Applicative.pure(Control_Applicative.applicativeArray)(xs);
        };
        return Data_Array.cons(Data_Array.take(n)(xs))(chunksOf(n)(Data_Array.drop(n)(xs)));
    };
};
var readGrid = function (cellSet) {
    return function (s) {
        var $90 = Data_String_CodePoints.length(s) !== 81;
        if ($90) {
            return new Data_Either.Left("input must be exactly 81 characters long");
        };
        return Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Either.applicativeEither)(Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Either.applicativeEither)(readCell(cellSet)))(chunksOf(9)(Data_String_CodeUnits.toCharArray(s)));
    };
};
var readNumberGrid = function (s) {
    return Control_Bind.bindFlipped(Data_Either.bindEither)(function (cellSet) {
        return readGrid(cellSet)(s);
    })(mkCellSet(".")([ "1", "2", "3", "4", "5", "6", "7", "8", "9" ]));
};
var cellShow = new Data_Show.Show(function (v) {
    if (v instanceof Fixed) {
        return Data_String_CodeUnits.fromCharArray([ v.value0 ]);
    };
    if (v instanceof Possible) {
        return ".";
    };
    throw new Error("Failed pattern match at Sudoku.Internal (line 32, column 1 - line 34, column 28): " + [ v.constructor.name ]);
});
var gridString = (function () {
    var $116 = Data_String_Common.joinWith("");
    var $117 = Data_Functor.map(Data_Functor.functorArray)((function () {
        var $119 = Data_String_Common.joinWith("");
        var $120 = Data_Functor.map(Data_Functor.functorArray)(Data_Show.show(cellShow));
        return function ($121) {
            return $119($120($121));
        };
    })());
    return function ($118) {
        return $116($117($118));
    };
})();
var cellSetShow = new Data_Show.Show(function (v) {
    return "CellSet " + (Data_Show.show(Data_Show.showChar)(v.value0) + (" " + Data_Show.show(Data_Show.showArray(Data_Show.showChar))(v.value1)));
});
var cellSetFromPuzzle = function (str) {
    return mkCellSet(".")(Data_Array["delete"](Data_Eq.eqChar)(".")(Data_Foldable.foldl(Data_Foldable.foldableArray)(function (arr) {
        return function (c) {
            var $97 = Data_Foldable.elem(Data_Foldable.foldableArray)(Data_Eq.eqChar)(c)(arr);
            if ($97) {
                return arr;
            };
            return Data_Array.cons(c)(arr);
        };
    })([  ])(Data_String_CodeUnits.toCharArray(str))));
};
var cellEq = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Fixed && y instanceof Fixed) {
            return x.value0 === y.value0;
        };
        if (x instanceof Possible && y instanceof Possible) {
            return Data_Eq.eq(Data_Eq.eqArray(Data_Eq.eqChar))(x.value0)(y.value0);
        };
        return false;
    };
});
module.exports = {
    CellSet: CellSet,
    Fixed: Fixed,
    Possible: Possible,
    Standard: Standard,
    UniqueDiagonal: UniqueDiagonal,
    NoSolution: NoSolution,
    Unique: Unique,
    NotUnique: NotUnique,
    "NoSolution'": NoSolution$prime,
    "NotUnique'": NotUnique$prime,
    "AtLeast'": AtLeast$prime,
    numbers: numbers,
    colors: colors,
    showGrid: showGrid,
    gridString: gridString,
    mkCellSet: mkCellSet,
    cellSetFromPuzzle: cellSetFromPuzzle,
    readCell: readCell,
    readGrid: readGrid,
    readNumberGrid: readNumberGrid,
    showGridWithPossibilities: showGridWithPossibilities,
    replace2D: replace2D,
    index2D: index2D,
    replaceAt: replaceAt,
    emptySudoku: emptySudoku,
    diagonalOf: diagonalOf,
    Tuple3: Tuple3,
    unique: unique,
    isUnique: isUnique,
    "isUnique'": isUnique$prime,
    chunksOf: chunksOf,
    transpose: transpose,
    zip3: zip3,
    on: on,
    toEither: toEither,
    randomArray: randomArray,
    cellSetShow: cellSetShow,
    cellEq: cellEq,
    cellShow: cellShow,
    searchResultShow: searchResultShow,
    functorSearchResult: functorSearchResult
};
